export type CommunityFilter = 'lost' | 'adoption' | 'milestone';

const types: Record<CommunityFilter, string> = {
  lost: 'lost_pet',
  adoption: 'adoption_post',
  milestone: 'milestone',
};

const legacyKeywords = {
  adoption: /\b(adopt|adopci[óo]n|rehome|en adopci[óo]n)/i,
  milestone: /\b(milestone|birthday|cumplea[ñn]os|anniversary|aniversario)/i,
};

export function matchesCommunityFilter(
  post: { post_type?: string | null; caption?: string | null; lost_resolved_at?: string | null },
  filter: CommunityFilter,
): boolean {
  if (post.post_type === 'profile_photo') return false;
  if (post.post_type === 'lost_pet' && post.lost_resolved_at) return false;
  if (post.post_type === types[filter]) return true;
  // Only registered alerts belong in Lost; caption text is not proof of an emergency.
  if (filter === 'lost') return false;
  return legacyKeywords[filter].test(post.caption || '');
}